// extracted by mini-css-extract-plugin
export default {"container":"chat_container__lPdKo","channelList":"chat_channelList__hIVvF","messageList":"chat_messageList__kRC9T"};